import React from 'react'
import classnames from 'classnames'

export default function Label({
  children,
  id,
  className,
  inline = false,
  ...props
}) {
  const cs = classnames(
    'font-weight-bold shade-05 margin-bottom-normal flexbox-align-center',
    {
      flexbox: inline === false,
      'inline-flex': Boolean(inline),
    },
    className
  )

  return (
    <label className={cs} htmlFor={id} {...props}>
      {children}
    </label>
  )
}
